<template>
<v-container>

  <v-flex>
    <v-card class="elevation-1">
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">Agencies</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 lg2 class="pt-3 pl-4">
          <v-text-field
            append-icon="search"
            label="Search by ID"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn color="primary" dark @click="newAgency">New Agency
          <v-icon dark right>add</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-badge overlap color="red">
            <span slot="badge" v-if="approvedCounter > 0">{{ approvedCounter }}</span>
          </v-badge>
        </v-card-actions>
      </v-card-title>
        <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            v-bind:search="search"
            :loading="loading"
            :custom-filter="customFilter"
            hide-actions
            
            no-results-text="We could not find agency based on your search."
          >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>
              
                <v-layout justify-center
                    align-center>
                    <v-flex>
                      <v-avatar
                              :size="avatarSize"
                              :tile="false"
                            >
                            <img :src="props.item.logo_url || defaultLogo" alt="logo">
                        </v-avatar>
                    </v-flex>
                </v-layout>
              
            </td>
            <td>{{ props.item.company || "something" }}</td>
            <td>{{ props.item.email }}</td>
            <td class="text-xs-center">{{ props.item.approved | booleanify}}</td>
            <td class="text-xs-center">{{ props.item.is_disabled | booleanify}}</td>
            <td class="text-xs-center">{{ props.item.is_provider | booleanify}}</td>
            <td>
                <v-layout align-center>
                  <v-flex>
                    <v-btn
                      @click="showAgency(props.item)" 
                      small 
                      dark color="primary"
                      >
                      show
                      </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn 
                      @click="editAgency(props.item)" 
                      small 
                      dark
                      >edit
                      </v-btn>
                  </v-flex>
                  <v-flex v-if="props.item.is_disabled === '1'">
                    <v-btn 
                      small
                      dark
                      color="warning"
                      >Disabled
                      </v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-btn 
                      @click="disableUser(props.item.id)" 
                      small 
                      dark
                      color="red"
                      >Disable
                      </v-btn>
                  </v-flex>
                </v-layout>
              
              </td>
            
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            Showing {{ pageStart }} to {{ pageStop }} Total: {{ items.length}}
          </template>
        </v-data-table>
    </v-card>
  </v-flex>
</v-container>
</template>

<script>
import axios from "axios";
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
  data() {
    return {
      max25chars: v => v.length <= 25 || "Input too long!",
      tmp: "",
      loading: true,
      approvedCounter: 0,
      search: "",
      pagination: {},
      defaultLogo: defaultLogo,
      headers: [
         {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Logo",
          align: "left",
          sortable: false,
          value: "logo"
        },
        {
          text: "Company",
          align: "left",
          sortable: false,
          value: "company"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "Approved",
          align: "center",
          sortable: false,
          value: "approved"
        },
        {
          text: "Disabled",
          align: "center",
          sortable: false,
          value: "is_disabled"
        },
        {
          text: "Provider",
          align: "center",
          sortable: false,
          value: "is_provider"
        }
      ],
      items: []
    };
  },
  filters: {
    booleanify: function(value) {
      if (value === "0") {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  computed: {
    avatarSize() {
      return `40px`;
    }
  },
  methods: {
    customFilter(items, search, filter) {
      search = search.toString().toLowerCase()
      let a = items.filter(row => filter(row["id"], search)) 
      if (!Array.isArray(a) || !a.length) {
        a = items.filter(row => filter(row["company"], search)) 
      } 
      return a;
    },
    disableUser(id) {
      axios
        .put("/users/" + id, {
          user: {
            disabled: "1"
          }
        })
        .then(res => {
          this.getAgencies();
        });
    },
    editAgency(item) {
      this.$router.push({ path: `/agency/agencies/edit/${item.id}` });
    },
    showAgency(item) {
      this.$router.push({ path: `/agency/agencies/show/${item.id}` });
    },
    newAgency() {
      this.$router.push("/agency/agencies/new");
    },
    getAgencies() {
      axios
      .get("/agencies")
      .then(response => {
        this.items = response.data.users;
        this.loading = false
      }).catch(error => {
        this.loading = false
      });
    }
  },
  mounted() {
    this.getAgencies();
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/agency/Agencies/Agencies.vue